/**
 * Aiká — Carrossel de valores (título + imagem + descrição)
 * Troca de slide por crossfade (opacidade), automático e por clique
 * nas bolinhas — mesmo mecanismo da barra de anúncios.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-values-carousel]').forEach((stage) => {
    const section = stage.closest('.aika-values-carousel');
    const slides = Array.from(stage.querySelectorAll('[data-values-slide]'));
    const dots = section ? Array.from(section.querySelectorAll('[data-values-dot]')) : [];
    if (slides.length <= 1) return;

    const speedSeconds = parseInt(stage.dataset.speed, 10) || 5;

    let current = 0;
    let timer;

    const goTo = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    };

    const startAutoplay = () => {
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), speedSeconds * 1000);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.valuesDot, 10);
        goTo(index);
        startAutoplay();
      });
    });

    const prevBtn = section ? section.querySelector('[data-values-prev]') : null;
    const nextBtn = section ? section.querySelector('[data-values-next]') : null;

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goTo(current - 1);
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goTo(current + 1);
        startAutoplay();
      });
    }

    goTo(0);
    startAutoplay();

    stage.addEventListener('mouseenter', () => clearInterval(timer));
    stage.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(timer);
      } else {
        startAutoplay();
      }
    });
  });
});
